import type {
    GroupCollection,
    GroupCollectionGroupCountsRequest,
    GroupCollectionsClientInterface,
} from './groupCollectionsClient.types';
import BaseClient from '../BaseClient';
import type { QueryParams } from '~/services/api';

export default class OrgUnitGroupCollectionsClient extends BaseClient implements GroupCollectionsClientInterface {
    constructor(private teamId: number, private orgUnitId: number) {
        super();
    }

    getGroupCollections(params?: QueryParams) {
        const url = `/api/v3/teams/${this.teamId}/org-units/${this.orgUnitId}/group-collections`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    getGroupCollection(groupCollectionId: number) {
        const url = `/api/v3/teams/${this.teamId}/org-units/${this.orgUnitId}/group-collections/${groupCollectionId}`;
        return this.makeCoreApiRequest(url, 'get');
    }

    createGroupCollection(data: GroupCollection) {
        const url = `/api/v3/teams/${this.teamId}/org-units/${this.orgUnitId}/group-collections`;
        return this.makeCoreApiRequest(url, 'post', data);
    }

    updateGroupCollection(groupCollectionId: number, data: GroupCollection) {
        const url = `/api/v3/teams/${this.teamId}/org-units/${this.orgUnitId}/group-collections/${groupCollectionId}`;
        return this.makeCoreApiRequest(url, 'put', data);
    }

    deleteGroupCollection(groupCollectionId: number) {
        const url = `/api/v3/teams/${this.teamId}/org-units/${this.orgUnitId}/group-collections/${groupCollectionId}`;
        return this.makeCoreApiRequest(url, 'delete');
    }

    getGroupCollectionsGroupCounts(params?: QueryParams) {
        const url = `/api/v3/teams/${this.teamId}/org-units/${this.orgUnitId}/group-collections/group-counts`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    getGroupCollectionsGroupMemberships(params?: GroupCollectionGroupCountsRequest) {
        const url = `/api/v3/teams/${this.teamId}/org-units/${this.orgUnitId}/group-collections/group-memberships`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }
}
